import * as React from "react";

function SvgTime(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={16.549} height={16.549} {...props}>
        <path data-name="Path 43731" d="M6.052 4.323h1.517v3.793h3.793v1.517h-5.31z" fill="#039be5" />
        <path
          data-name="Path 43732"
          d="M16.549 8.275A8.275 8.275 0 118.275 0a8.275 8.275 0 018.274 8.275zm-1.655 0a6.62 6.62 0 11-6.62-6.62 6.62 6.62 0 016.62 6.62z"
          fill="#039be5"
          fillRule="evenodd"
        />
      </svg>
    </span>
  );
}

export default SvgTime;
